export type IBarrierSelectedToModal = {
    highlightDegradedBarriers: boolean
}
export type IBarrierSelectedToModalAction = {
    type: 'SET_HIGHLIGHT_DEGRADED_BARRIERS'
    payload: {
        newHighlightDegraded: boolean
    }
}

const initialState: IBarrierSelectedToModal = {
    highlightDegradedBarriers: false
}

export function highlightDegradedBarriersReducer(
    state = initialState,
    action: IBarrierSelectedToModalAction
): IBarrierSelectedToModal {
    switch (action.type) {
        case 'SET_HIGHLIGHT_DEGRADED_BARRIERS':
            return { highlightDegradedBarriers: action.payload.newHighlightDegraded ?? false }

        default:
            return state
    }
}
